// eslint-disable-next-line import/prefer-default-export
export const orderTypeDisplayName = {
  newest: 'Newest',
  unanswered: 'Unanswered',
  active: 'Active',
  mostViewed: 'Most Viewed',
} as const;

/**
 * The standard board size for a BattleShip game.
 */
export const BOARD_SIZE = 10; // Standard board size

/**
 * The status of a cell on the BattleShip board.
 * - `EMPTY`: No ship present, not attacked
 * - `SHIP`: Ship present, not attacked
 * - `MISS`: Attacked, no ship
 * - `HIT`: Attacked, ship hit
 */
export const cellStatus = {
  EMPTY: 'EMPTY',
  SHIP: 'SHIP',
  MISS: 'MISS',
  HIT: 'HIT',
} as const;
